<template>
    <div>
      <h3>Detalhes do Workflow</h3>
      <button
          @click="irParaUltimaTarefa"
      >
        Ver Última Tarefa
      </button>
      <pre>{{ workflow }}</pre>
    </div>
  </template>
  
  <script>
  export default {
    name: 'WorkflowRecuperacaoDetalhesComponent',
    props: {
      workflow: {
        type: Object,
        required: true
      }
    },
    methods: {
      irParaUltimaTarefa() {
        console.log(this.workflow?.pco_workflow?.ultima_tarefa?.id);
        const id = this.workflow?.pco_workflow?.ultima_tarefa?.id;
        if (!id) return

        this.$router.push(`/workflow/ficha-tecnica-tarefa/${id}`)
      }
    }
  }
  </script>
  